module.exports = __webpack_public_path__ + "media/images/preview_diary_3-9775b9694f13d8a234d1a0f82eae210b.webp";